<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>对公转账处方记录</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>

    <div style="padding: 20px">
      <div class="container">
        <div style="margin-bottom: 30px">
          <span>
            <span>处方总金额：</span>
            <span>{{ codeInfo.total_price }}</span>
          </span>
          <span style="margin: 0 50px">
            <span>处方数量：</span>
            <span>{{ codeInfo.total_num }}</span>
          </span>
          <span>
            <span>转账备注：</span>
            <span>{{ codeInfo.remark }}</span>
          </span>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="codeInfo.list"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="开方时间"
              prop="create_time"
            ></el-table-column>
            <el-table-column label="患者信息">
              <template slot-scope="scope">
                <div>{{ scope.row.user_name }}</div>
                <div>
                  <span v-if="scope.row.sex == 1">男</span>
                  <span v-if="scope.row.sex == 2">女</span>
                  <span v-if="scope.row.sex == 0">未知</span>
                  <span style="margin-left: 10px">{{ scope.row.age }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="科室"
              prop="department_name"
            ></el-table-column>
            <el-table-column label="医生信息">
              <template slot-scope="scope">
                <div>{{ scope.row.doctor_name }}</div>
                <div>
                  <span v-if="scope.row.doctor_sex == 1">男</span>
                  <span v-if="scope.row.doctor_sex == 2">女</span>
                  <span style="margin-left: 10px">{{ scope.row.title }}</span>
                </div>
                <div>{{ scope.row.phone }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="药品剂型"
              prop="drug_type_name"
            ></el-table-column>
            <el-table-column
              label="药品金额"
              prop="drug_price"
            ></el-table-column>
            <el-table-column
              label="加工费"
              prop="drug_machining_price"
            ></el-table-column>
            <el-table-column
              label="诊后管理费"
              prop="consult_drug_price"
            ></el-table-column>
            <el-table-column label="诊金">
              <template slot-scope="scope">
                <span>{{
                  scope.row.consulting_gold == '0.00'
                    ? '免费'
                    : scope.row.consulting_gold
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="是否隐藏剂量">
              <template slot-scope="scope">
                <span>{{ scope.row.is_show == 1 ? '否' : '是' }}</span>
              </template>
            </el-table-column>

            <el-table-column label="处方状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待取药</span>
                <span v-if="scope.row.status == 2">待审方</span>
                <span v-if="scope.row.status == 3">已通过</span>
                <span v-if="scope.row.status == 4">已抓药</span>
                <span
                  v-if="
                    scope.row.status == 5 ||
                    scope.row.status == 6 ||
                    scope.row.status == 7 ||
                    scope.row.status == 8
                  "
                  >微信开方</span
                >
              </template>
            </el-table-column>
            <el-table-column label="处方来源">
              <template slot-scope="scope">
                <span v-if="scope.row.pre_type == 1">问诊开方</span>
                <span v-if="scope.row.pre_type == 2">直接开方</span>
                <span v-if="scope.row.pre_type == 4">云诊所开方</span>
                <span v-if="scope.row.pre_type == 5">手机号开方</span>
                <span v-if="scope.row.pre_type == 6">微信开方</span>
                <span v-if="scope.row.pre_type == 7">视频开方</span>
                <span v-if="scope.row.pre_type == 8">按方购药</span>
                <span v-if="scope.row.pre_type == 9">拍方购药</span>
                <span v-if="scope.row.pre_type == 10">开放平台开方</span>
                <span v-if="scope.row.pre_type == 11">医生拍照开方</span>
                <div v-if="scope.row.org_name">{{ scope.row.org_name }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      codeInfo: {}
    };
  },

  methods: {
    //获取详情
    getDetail() {
      let accounts_id = this.$route.query.accounts_id;
      this.axios
        .post('platform/prescription/getPrescriptionAccountsInfo', {
          accounts_id
        })
        .then((res) => {
          if (res.code == 0) {
            this.codeInfo = res.data;
            this.codeInfo.list = this.codeInfo.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm');
              return item;
            });
          }
        });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  border-radius: 5px;
  text-align: left;
}
.inbobox {
  display: flex;
  .inboitem {
    padding: 14px 50px 14px 20px;
    box-sizing: border-box;
    margin-bottom: 12px;
    margin-right: 20px;
    background-color: #f9f8ee;
    border: solid 1px #dad8ca;
    .infotitle {
      width: 90px;
      display: inline-block;
    }
  }
}
.title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 14px;
}
.itembox {
  display: flex;
  color: #000;
  flex-wrap: wrap;
  .item {
    width: 180px;
    display: flex;
    justify-content: space-between;
    margin-right: 40px;
    position: relative;
    margin-bottom: 22px;
  }
  .item::before {
    content: '';
    position: absolute;
    height: 12px;
    width: 1px;
    background: #d7d7d7;
    left: 200px;
    top: 4px;
  }
}
</style>
